import * as React from 'react';
import { IPopupCloseIconButtonProps } from '../PopupCloseIconButton.types';
import { TestIds } from '../constants';
import { activateBySpaceButton } from '../../../core/commons/a11y';
import style from './style/PopupCloseIconButton.scss';

const PopupCloseIconButton: React.FC<IPopupCloseIconButtonProps> = ({
  id,
  svgContent,
  onClick,
}) => {
  const title = 'Back to site';

  return (
    <div
      id={id}
      className={style.svgRoot}
      onKeyDown={activateBySpaceButton}
      data-testid={TestIds.PopupCloseIconButtonRoot}
      onClick={() => onClick && onClick()}
    >
      <div
        tabIndex={0}
        role={'button'}
        title={title}
        aria-label={title}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </div>
  );
};

export default PopupCloseIconButton;
